/** @file Hierarchy panel registration: the bone/slot tree with its Delete binding. */
import type { PanelEntry } from '../panelEntry';
import { bindings } from './bindings';
import { HierarchyPanel } from './HierarchyPanel';

/** Docked left of the viewport by default. */
export const panel: PanelEntry = { id: 'hierarchy', title: 'panels.hierarchy.title', bindings, component: HierarchyPanel };
